import { url, model } from '@/configs/global'

class PlanoFrequencia extends model{
    constructor(data, axios) {
        super()
        for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
                this[key] = data[key]
            }
        }
        this.axios = axios
        this.model_type = 'plano_frequencia'

        this.listaCriacao = [
            {label: 'description', type: 'text', labelInput: 'Descrição'},
            {label: 'repeat_each_days', type: 'text', labelInput: 'Frequência'},
        ]
        this.listaAtualizacao = this.listaCriacao

        this.concat = ['plan_id']
    }

    async create({getters}){
        const obj = this.filterCreate()
        const id_e = getters['empresa.get'].id
        return await this.axios.post(`${url}/api/${id_e}/save_plan_frequency`, obj)
    }

    async update({getters}){
        const obj = this.filterUpdate()
        const id_e = getters['empresa.get'].id
        return await this.axios.put(`${url}/api/${id_e}/update_plan_frequency/${this.id}`, obj)
    }

}

export default PlanoFrequencia